import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const GridRowCardByRowContainer = styled.div`
  width: 100%;
  display: grid; /* Change to grid */
  /* Define your columns. You can use 'auto-fit' for responsiveness */
  /* Example for 7 columns (adjust based on your max number of items): */
  grid-template-columns: minmax(230px, 1fr) minmax(125px, 1fr) minmax(140px, 1fr) minmax(150px, 1fr) 1fr 1fr 1fr; /* Adjust these values */
  /* If you want to use the conditional rendering, you'll need to adapt the grid-template-columns */
  /* Or use grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); and let items resize */

  background: ${colors.white};
  border-radius: 18px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  
  & + & {
    margin-top: 15px;
  }
`;

export const GridRowCardByRowItem = styled.div`
  width: 100%; /* Keep this if you want it to behave like a block initially */
  float: left; /* This might be redundant with flexbox, consider removing */
  display: flex;
  flex-direction: column;
  padding: 20px 0px 0px 15px;
  flex-grow: 1; /* Allow items to grow and take available space */
  flex-basis: 0; /* Important for flex-grow to work as expected */

  &:last-child {
    padding-right: 15px;
    align-items: flex-end;
    flex-grow: 0; /* Prevent the last item from growing if it contains buttons */
    flex-basis: auto; /* Allow the last item to size based on its content */
  }

  /* Define min-widths for specific content if absolutely necessary,
     but try to let flex-grow handle most of it.
     If you need specific widths for specific items, consider adding a prop
     to the component and styling based on that.
  */
  /* Example:
  &.client-info {
    min-width: 230px;
  }
  */
`;

export const GridRowCardByRowStrong = styled.strong`
  color: ${colors.textPrimary};
  font-size: 12px;
  font-weight: 700;
  line-height: 17px;
`;

export const GridRowCardByRowLabel = styled.span`
  font-size: 12px;
  color: ${colors.textSecondary};
  line-height: 17px;

  &:last-child {
    flex: 1;
  }
`;

export const GridRowCardByRowValue = styled.span`
  font-size: 12px;
  color: ${colors.textPrimary};
  line-height: 17px;

  strong {
    font-weight: bold;
    color: ${colors.textPrimary};
  }
`;

export const GridRowCardByRowButton = styled.button`
  width: 24px;
  height: 24px;
  border: 1px solid ${colors.textSecondary};
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 12px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
    -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
  -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const AnularFooterButton = styled.span`
  margin-top: 70px;
  text-decoration: underline;
  color: ${colors.textHyperlink};
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: .2s;

  &:hover {
    color: ${colors.bgSecondaryHover};
  }
`;
